import type { MouseEventHandler, ReactNode, TouchEventHandler } from 'react';
import Link from 'next/link';
import { cn } from '@/lib/utils';

interface ApartmentCardFrameProps {
  href: string;
  ariaLabel: string;
  children: ReactNode;
  className?: string;
  linkClassName?: string;
  target?: string;
  rel?: string;
  prefetch?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  onMouseEnter?: MouseEventHandler<HTMLElement>;
  onMouseLeave?: MouseEventHandler<HTMLElement>;
  onTouchStart?: TouchEventHandler<HTMLElement>;
  onTouchEnd?: TouchEventHandler<HTMLElement>;
  dataApartmentId?: string;
}

export default function ApartmentCardFrame({
  href,
  ariaLabel,
  children,
  className,
  linkClassName,
  target,
  rel,
  prefetch = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onTouchStart,
  onTouchEnd,
  dataApartmentId,
}: ApartmentCardFrameProps) {
  return (
    <article
      className={cn(
        'group relative w-full overflow-hidden rounded-2xl border border-[#E8E1D4] bg-[#FDFBF7] shadow-[0_2px_16px_-4px_rgba(0,0,0,0.06)] transition-all duration-300 hover:-translate-y-px hover:border-[#D8D1C5] hover:shadow-[0_14px_34px_-26px_rgba(15,23,42,0.45)]',
        className
      )}
      data-apartment-id={dataApartmentId}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <Link
        href={href}
        target={target}
        rel={rel}
        prefetch={prefetch}
        onClick={onClick}
        aria-label={ariaLabel}
        className={cn(
          'absolute inset-0 z-10 rounded-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2',
          linkClassName
        )}
      >
        <span className="sr-only">{ariaLabel}</span>
      </Link>
      {children}
    </article>
  );
}
